export default function truncateWords(text, maxWords) {
    const words = text.split(' ');
    const truncated = words.slice(0, maxWords).join(' ');
    return truncated;
}